// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fp","gallery__header":"c-q_fq","gallery__thumbs":"c-q_fr"};